import { HardTermination } from '../shared';

const Emergency = () => (
  <HardTermination
    title="Unfortunately, we can’t provide care in an emergency"
    body="If you or someone you know is in crisis, call 911 or the National Suicide Prevention Hotline at 988 right away."
    buttonText="Go to 988lifeline.org"
    url="https://988lifeline.org/"
  />
);

export default Emergency;
